import { render, staticRenderFns } from "./sowhatbuy-card-image.vue?vue&type=template&id=38c722df&"
import script from "./sowhatbuy-card-image.vue?vue&type=script&lang=js&"
export * from "./sowhatbuy-card-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports